/**
 * @since 2026-04-18
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 *
 * Pluggable panel registry. Keys must match DatasetCheck.Name on the backend.
 * Adding a new check = drop in a panel folder and register it here.
 */

import PriceAdjustmentPanel from "./PriceAdjustmentPanel";
import SourceDisagreementPanel from "./SourceDisagreementPanel";
import FuturesRollPanel from "./FuturesRollPanel";
import GapCalendarPanel from "./GapCalendarPanel";
import ReturnsDistributionPanel from "./ReturnsDistributionPanel";
import IntradayPatternPanel from "./IntradayPatternPanel";
import HistoryLengthPanel from "./HistoryLengthPanel";
import DaysSinceLastUpdatePanel from "./DaysSinceLastUpdatePanel";
import LiquidityVolumePanel from "./LiquidityVolumePanel";
import OhlcIntegrityPanel from "./OhlcIntegrityPanel";

const CheckPanelRegistry = {
  PriceAdjustment: PriceAdjustmentPanel,
  SourceDisagreement: SourceDisagreementPanel,
  FuturesRoll: FuturesRollPanel,
  GapCalendar: GapCalendarPanel,
  ReturnsDistribution: ReturnsDistributionPanel,
  IntradayPattern: IntradayPatternPanel,
  HistoryLength: HistoryLengthPanel,
  DaysSinceLastUpdate: DaysSinceLastUpdatePanel,
  LiquidityVolume: LiquidityVolumePanel,
  OhlcIntegrity: OhlcIntegrityPanel,
};

export default CheckPanelRegistry;
